import {
    CarouselHeader,
    CarouselNavigation,
    CarouselTitle,
    NavDirections,
    SlideConfig,
} from '@eventbrite/collection-carousel';
import { GenericLazyString } from '@eventbrite/i18n';
import React, { ReactElement } from 'react';
import { OrganicEventSearchFiltersApiPayload } from '../../../../api/searchOrganicEvents';
import { FormattedLocationResponse } from '../../../../pages/categoryBrowse/api';
import { CategoryContent } from '../../constants';
import { SingleSubCategory } from './components/SingleSubCategory';
import './RelatedCategoriesCarousel.scss';
interface RelatedCategoriesCarouselProps {
    headerTitle?: string | GenericLazyString | ReactElement;
    useSideNavigation?: boolean;
    slidesVisible: SlideConfig;
    location: FormattedLocationResponse;
    filteredSubCategories: { key: string }[];
    query: OrganicEventSearchFiltersApiPayload;
    activeTag: CategoryContent;
}

interface RelatedCategoriesDynamicCSS extends React.CSSProperties {
    '--show-side-nav-for-lesser-slides': string;
    '--title-margin': string;
}

export const RelatedCategoriesCarousel: React.FunctionComponent<
    RelatedCategoriesCarouselProps
> = (props) => {
    const {
        headerTitle,
        filteredSubCategories,
        location,
        query,
        activeTag,
        slidesVisible,
    } = props;

    const [disabledNav, setDisabledNav] = React.useState<
        NavDirections | undefined
    >(NavDirections.Left);
    const scrollContainerRef = React.useRef<HTMLUListElement>(null);

    const containerWidth = scrollContainerRef.current?.clientWidth || 0;
    const CTAWidth = 125,
        gapWidth = 24;

    const showNavComponent =
        props.useSideNavigation ||
        containerWidth <
            CTAWidth * filteredSubCategories.length +
                (filteredSubCategories.length - 1) * gapWidth;

    const componentStyle: RelatedCategoriesDynamicCSS = {
        '--show-side-nav-for-lesser-slides': showNavComponent ? 'flex' : 'none',
        '--title-margin': showNavComponent ? '0 0 0 auto' : 'auto',
    };

    return (
        <div className="related-categories-carousel" style={componentStyle}>
            <CarouselHeader>
                <CarouselTitle>{headerTitle}</CarouselTitle>
                {showNavComponent ? (
                    <CarouselNavigation
                        childrenLength={filteredSubCategories.length}
                        slidesVisible={slidesVisible}
                        handleClick={(direction: NavDirections) => {
                            const normalizedContainerWidth =
                                containerWidth * 0.5;
                            const scrollAmount =
                                direction === NavDirections.Right
                                    ? normalizedContainerWidth
                                    : normalizedContainerWidth * -1;
                            scrollContainerRef?.current?.scrollBy({
                                left: scrollAmount,
                                behavior: 'smooth',
                            });
                        }}
                        leftDisabled={disabledNav === NavDirections.Left}
                        rightDisabled={disabledNav === NavDirections.Right}
                    />
                ) : null}
            </CarouselHeader>

            <div className={'carousel'}>
                <ul className="carousel-internal" ref={scrollContainerRef}>
                    {filteredSubCategories.map(
                        (subCategory: { key: string }, index: number) => (
                            <SingleSubCategory
                                key={index}
                                index={index}
                                subCategory={subCategory}
                                totalLength={filteredSubCategories.length}
                                setDisabledNav={setDisabledNav}
                                query={query}
                                location={location}
                                activeTag={activeTag}
                            />
                        ),
                    )}
                </ul>
            </div>
        </div>
    );
};
